import ThickChinaAvatarIcon from "@src/app/assets/author-default-thumbnail.jpg";
import type { BFFArticleCard, BFFAuthorDetail } from "@src/app/types/bff";
import type { ReactElement } from "react";

type Props = Readonly<{
  author: BFFArticleCard["authors"][0] | BFFAuthorDetail;
}>;

export default function EditorCard({ author }: Props): ReactElement {
  return (
    <div
      data-testid={`editor-card-${author.id}`}
      className="text-label-2 text-primary flex items-start gap-2"
    >
      <img
        src={author.imageUrl || ThickChinaAvatarIcon}
        alt={author.name}
        className="aspect-square size-20 rounded-full"
      />

      <div>
        <h4 className="text-header-4 text-primary font-bold">{author.name}</h4>
        {author.designation && (
          <span className={"text-label-2 text-tertiary block font-bold"}>
            {author.designation}
          </span>
        )}
      </div>
    </div>
  );
}
